module.exports = __webpack_public_path__ + "img/sim-oh-dip.7dd21b80.png";